import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

interface SimpleModalProps {
  isOpen: boolean
  toggle: (e: boolean) => void
  children: React.ReactNode
  header?: React.ReactNode
  footer?: React.ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl'
  dataBackdrop?: 'static'
  scrollable?: boolean
  fullscreen?: boolean | 'sm' | 'md' | 'lg' | 'xl'
}

const SimpleModal = ({
  isOpen,
  toggle,
  children,
  header,
  footer,
  size = 'md',
  dataBackdrop,
  scrollable,
  fullscreen
}: SimpleModalProps) => {
  return (
    <Modal
      size={size}
      isOpen={isOpen}
      toggle={() => dataBackdrop !== 'static' && toggle(!isOpen)}
      centered
      scrollable={scrollable}
      fullscreen={fullscreen}
    >
      {header && (
        <ModalHeader toggle={() => toggle(!isOpen)}>{header}</ModalHeader>
      )}
      <ModalBody>{children}</ModalBody>
      {footer && <ModalFooter>{footer}</ModalFooter>}
    </Modal>
  )
}

export default SimpleModal
